import React, { useState } from 'react';
import costindetail from '../img/amenities-6.jpeg';
import EnquiryModal from './EnquiryModal';

const priceData = [
  { type: 1, area: '520 Sq.Ft.', price: '₹ 42 Lakhs*' },
  { type: 2, area: '680 Sq.Ft.', price: '₹ 55 Lakhs*' },
  { type: 3, area: '700 Sq.Ft.', price: '₹ 57 Lakhs*' },
  { type: 4, area: '720 Sq.Ft.', price: '₹ 59 Lakhs*' },
  { type: 5, area: '740 Sq.Ft.', price: '₹ 60 Lakhs*' },
  { type: 6, area: '954 Sq.Ft.', price: '₹ 78 Lakhs*' },
  { type: 7, area: '1006 Sq.Ft.', price: '₹ 82 Lakhs*' },
];

const PriceSection = () => {
  const [hovered, setHovered] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showCostingModal, setCostingShowModal] = useState(false);

  return (
    <div className="m-4 p-3"> {/* Standard margin and padding around the whole section */}
      <div className="d-flex flex-column flex-md-row gap-4 align-items-start">
        {/* Left Side - Pricing Table */}
        <div className="flex-grow-1 w-100 w-md-65">
          <h4 className="fw-bold mb-3">Emperia Icon</h4>
          <div className="bg-dark text-white d-flex fw-bold py-2 px-3">
            <div className="col-2">Type</div>
            <div className="col-4">Area</div>
            <div className="col-6">Price Onwards</div>
          </div>
          {priceData.map(({ type, area, price }) => (
            <div key={type} className="d-flex align-items-center border-bottom py-3 px-3">
              <div className="col-2">{type}</div>
              <div className="col-4">{area}</div>
              <div className="col-6 d-flex align-items-center">
                {price}
                <button className="btn btn-dark btn-sm ms-3"
                  onClick={() => setShowModal(true)}
                >Price Breakup</button>
              </div>
            </div>
          ))}
        </div>

        {/* Right Side - Costing Image with Hover Title */}
        <div className="text-center w-100 w-md-auto">
          <h5 className="mb-3">Costing Details</h5>

          <div
            className="position-relative mx-auto"
            style={{ width: 'fit-content' }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          >
            <img
              src={costindetail}
              alt="Costing Details"
              className="img-fluid"
              style={{ filter: 'blur(3px)' }}
            />

            {hovered && (
              <div
                className="position-absolute top-50 start-50 translate-middle bg-white rounded p-3 shadow"
                style={{ zIndex: 1 }}
                onClick={()=>setCostingShowModal(true)}
              >
                <h5 className="fw-bold m-0 text-black" style={{ fontSize: '24px' }}>
                  Complete Costing Details
                </h5>
              </div>
            )}
          </div>
        </div>
      </div>
        <EnquiryModal
        show={showModal}
        onClose={() => setShowModal(false)}
        formtitle=" Price Breakup"
      />


        <EnquiryModal
        show={showCostingModal}
        onClose={() => setCostingShowModal(false)}
        formtitle=" Show Complete Costing"
      />
    </div>
  );
};

export default PriceSection;
